import { TableRow, styled, alpha } from '@mui/material';

const SBTableRow = styled(TableRow)(({ theme }) => ({
  position: 'relative',
  cursor: 'pointer',

  transition: 'all 0.28s cubic-bezier(0.4, 0, 0.2, 1)',

  // ✅ Glass background
  background: alpha(theme.palette.background.paper, 0.42),

  backdropFilter: 'blur(16px) saturate(180%)',
  WebkitBackdropFilter: 'blur(16px) saturate(180%)',

  borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,

  boxShadow: `
    inset 0 1px 0 ${alpha(theme.palette.common.white, 0.12)}
  `,

  overflow: 'hidden',

  '& > td:first-of-type > div': {
    borderLeft: 0,
  },

  // ✅ Selected state
  '&.selected': {
    background: alpha(theme.palette.primary.main, 0.12),

    boxShadow: `
      inset 4px 0 0 0 ${theme.palette.primary.main},
      inset 0 1px 0 ${alpha(theme.palette.common.white, 0.18)},
      0 8px 24px ${alpha(theme.palette.primary.main, 0.08)}
    `,
  },

  // ✅ Hover state
  '&:hover': {
    background: alpha(theme.palette.primary.main, 0.08),

    transform: 'translateX(4px) translateY(-1px)',

    boxShadow: `
      0 10px 28px ${alpha(theme.palette.common.black, 0.08)},
      inset 0 1px 0 ${alpha(theme.palette.common.white, 0.18)}
    `,
  },

  '&:active': {
    transform: 'translateX(4px) scale(0.995)',
  },

  '&.selected:hover': {
    background: alpha(theme.palette.primary.main, 0.14),
  },

  // ✅ Left glow indicator
  '&::after': {
    content: '""',
    position: 'absolute',

    left: 0,
    top: 6,
    bottom: 6,

    width: '4px',

    borderRadius: '0 12px 12px 0',

    background: 'transparent',

    transition: 'all 0.25s ease',
  },

  '&:hover::after': {
    background: `
      linear-gradient(
        to bottom,
        ${alpha(theme.palette.primary.light, 0.9)},
        ${theme.palette.primary.main}
      )
    `,

    boxShadow: `0 0 12px ${alpha(theme.palette.primary.main, 0.5)}`,
  },

  '&.selected::after': {
    background: `
      linear-gradient(
        to bottom,
        ${alpha(theme.palette.primary.light, 1)},
        ${theme.palette.primary.main}
      )
    `,
  },

  // ✅ Rounded corners effect
  '& td:first-of-type': {
    borderTopLeftRadius: '18px',
    borderBottomLeftRadius: '18px',
  },

  '& td:last-of-type': {
    borderTopRightRadius: '18px',
    borderBottomRightRadius: '18px',
  },

  // ✅ Reduced motion accessibility
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',

    '&:hover': {
      transform: 'none',
    },

    '&:active': {
      transform: 'none',
    },
  },
}));

export { SBTableRow };
